import { render, staticRenderFns } from "./DatasetAssetParameter.vue?vue&type=template&id=182dbebc&"
import script from "./DatasetAssetParameter.vue?vue&type=script&lang=ts&"
export * from "./DatasetAssetParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports